var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',_vm._l((_vm.restaurants),function(restaurant,index){return _c('v-card',{key:index,staticClass:"mx-auto my-12",attrs:{"to":{ name: 'restoran-dostava', params: { id: restaurant.id, name:restaurant.name} },"max-width":"374"}},[_c('v-img',{attrs:{"height":"250","src":_vm.conf.apiUrlBase +
          '/gallery/' +
          restaurant.id +
          '/' +
          restaurant.settings.logo}}),_c('v-card-title',[_vm._v(_vm._s(restaurant.name))]),_c('v-card-subtitle',[_vm._v(_vm._s(restaurant.address))]),_c('v-card-text')],1)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }